import { render, staticRenderFns } from "./ModelLabel.vue?vue&type=template&id=79c6b71e&scoped=true"
import script from "./ModelLabel.vue?vue&type=script&lang=js"
export * from "./ModelLabel.vue?vue&type=script&lang=js"
import style0 from "./ModelLabel.vue?vue&type=style&index=0&id=79c6b71e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c6b71e",
  null
  
)

export default component.exports